import React from "react";

import Navbar from "../components/Navbar/Navbar";
import DatenschutzContent from "../components/Datenschutz/DatenschutzContent";
import Footer from "../sections/Footer/Footer";

const Datenschutz = () => {
    return (
        <>
            <Navbar />

            <DatenschutzContent />

            <Footer />
        </>
    );
};

export default Datenschutz;